const ExpressionExplanation = () => {
  return (
    <section className="section">
      <h3 className="text-center">How Cron Express</h3>
      <table className="expression-table">
        <thead>
          <tr><th>*</th><th>*</th><th>*</th><th>*</th><th>*</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>minute (0-59)</td>
            <td>hour (0 - 23)</td>
            <td>day of the month (1 - 31)</td>
            <td>month (1 - 12)</td>
            <td>day of the week (0 - 6)</td>
          </tr>
        </tbody>
      </table>
    </section>
  )
}
export default ExpressionExplanation;